<template>
    <div>
        <b-row
            :class="[!element.selected ? 'font-italic' : '']"
            class="w-100 pt-3 m-0"
            align-v="start"
        >
            <div class="col-7 pl-0 pr-1">
                <!-- Tooltip targeting the wrapping div instead of the disabled checkbox -->
                <div
                    :id="`tooltip-target-${element.id}`"
                    class="d-inline-block w-100"
                >
                    <b-form-checkbox
                        :id="`bundle-item-checkbox-${element.id}`"
                        v-model="element.selected"
                        :disabled="element.disabled"
                        class="align-items-start"
                        plain
                    >
                        {{ element.name }}
                    </b-form-checkbox>
                </div>

                <!-- Tooltip message -->
                <b-tooltip
                    v-if="element.disabled && element.tooltip"
                    :target="`tooltip-target-${element.id}`"
                    placement="top"
                    triggers="hover"
                    :container="`#${parentId}`"
                >
                    {{ element.tooltip }}
                </b-tooltip>
            </div>
            <div
                :class="[isEstimate ? 'col-2' : 'col pr-0 pl-0']"
                class="min-quantity"
            >
                <div>
                    <input
                        :disabled="!element.selected"
                        :id="`min_quantity_${element.id}`"
                        v-model="element.quantity"
                        v-validate="'required|decimal:3|min_value:0'"
                        :name="`min_quantity_${element.id}`"
                        :class="{
                            'border-danger': errors.has(
                                'min_quantity_' + element.id
                            )
                        }"
                        type="number"
                        min="0"
                        step="any"
                        class="form-control"
                        @wheel="event => event.target.blur()"
                        aria-describedby="unit1"
                    />
                    <span id="unit1" v-if="isEstimate">
                        {{ element.unit }}
                    </span>
                </div>
                <div v-if="showTagField">
                    <input
                        :disabled="!element.selected"
                        :id="`tag_number_${element.id}`"
                        v-model="element.tag_number"
                        :name="`tag_number_${element.id}`"
                        class="form-control tag-number"
                        placeholder="Tag"
                    />
                </div>
                <div
                    v-if="!isEstimate && element.send_to_lab"
                    class="sendToLab"
                    style="min-height: 1.5rem;"
                >
                    <b-form-checkbox
                        :id="`send_to_lab_${element.id}`"
                        :disabled="!element.selected"
                        v-model="element.send_to_lab_value"
                        class="position-absolute pt-2"
                        plain
                    >
                        <span
                            v-if="element.source.indexOf('IDEXX_DEVICE') == 0"
                            class="text-nowrap"
                            >&nbsp;Send to VetLab</span
                        >
                        <span
                            v-else-if="
                                element.source == 'ASTERIS' ||
                                element.source == 'IDEXX_DR' ||
                                element.source == 'SOUNDPACS'
                            "
                            class="text-nowrap"
                            >&nbsp;Send to device</span
                        >
                        <span
                            v-else-if="
                                element.source == 'HESKA_CLOUD' ||
                                (element.source == 'ANTECH' &&
                                    element.code == 'Y')
                            "
                            class="text-nowrap"
                            >&nbsp;Send to analyzer</span
                        >
                        <span v-else class="text-nowrap"
                            >&nbsp;Send to lab</span
                        >
                    </b-form-checkbox>
                </div>
            </div>
            <div
                :class="[isEstimate ? 'col-2' : 'col pl-2 pt-1']"
                class="max-quantity"
            >
                <span
                    v-if="isEstimate"
                    style="position: absolute; left: -0.3em;"
                    >-</span
                >
                <input
                    v-if="isEstimate"
                    :disabled="!element.selected"
                    :id="`max_quantity_${element.id}`"
                    v-model="element.max_quantity"
                    v-validate="maxQuantityValidateRules"
                    :name="`max_quantity_${element.id}`"
                    :class="{
                        'border-danger': errors.has(
                            'max_quantity_' + element.id
                        )
                    }"
                    type="number"
                    min="0"
                    step="any"
                    class="form-control"
                    aria-describedby="unit2"
                />
                <span id="unit2" class="max-quantity-unit">
                    {{ element.unit }}
                </span>
            </div>
            <div class="col-1 btn-dosage ml-auto p-0">
                <dosage
                    :target="`btn-dosage-${element.id}`"
                    :data="element"
                    :weight-data="{
                        weight: appData.weight,
                        uom: appData.uom
                    }"
                    parent-id="checkInModal"
                    class="btn-sm"
                />
            </div>
        </b-row>

        <hr class="mb-0" />
    </div>
</template>
<script>
import Dosage from "@/module/commons/dosage.vue";
import ITEMTYPES from "@/constants/item-types";
export default {
    components: {
        Dosage
    },
    inject: ["$validator"],
    props: {
        element: {
            type: Object,
            default() {
                return { selected: true };
            }
        },
        appData: {
            type: Object,
            default() {}
        },
        isEstimate: Boolean
    },
    computed: {
        showTagField() {
            const shouldShowTagInput =
                !this.appData || this.appData.record_option != 1; // Default true, record_option 1 is Dont create record"
            return (
                !this.isEstimate &&
                this.checkElementIsRabies(this.element) &&
                shouldShowTagInput
            );
        },
        maxQuantityValidateRules() {
            const quantity = this.element.quantity;
            let validation = `decimal:3`;
            if (quantity == 0) {
                validation += "|min_value:0.001";
            } else {
                validation += `|min_value:${quantity}`;
            }
            // const quantity =
            //     this.element.quantity === 0 ? 0.001 : this.element.quantity;
            // return `required|min_value:${quantity}|decimal:3`;
            return validation;
        }
    },
    data() {
        return {
            parentId: null
        };
    },
    watch: {
        "element.selected"(value, oldValue) {
            this.$emit("selected", value);
            // Trigger stateChanged when selection changes programmatically
            if (value !== oldValue) {
                this.stateChanged(value);
            }
        },
        "element.quantity"() {
            if (this.isEstimate) {
                this.$validator.validate(`max_quantity_${this.element.id}`);
            }
        }
    },
    mounted() {
        // this.element.selected = false;

        // Traverse up to find the closest modal element
        let el = this.$el;
        while (el && el !== document.body) {
            if (el.classList.contains("modal")) {
                this.parentId = el.id || null;
                break;
            }
            el = el.parentElement;
        }
    },
    methods: {
        stateChanged(event) {
            if (event) {
                if (this.element.originalQuantity) {
                    this.element.quantity = this.element.originalQuantity;
                    this.element.max_quantity = this.element.originalMaxQuantity;
                }
                if (this.element.originalMaxQuantity) {
                    this.element.max_quantity = this.element.originalMaxQuantity;
                }
                if (this.element.originalTagNumber) {
                    this.element.tag_number = this.element.originalTagNumber;
                }
            } else {
                this.element.originalQuantity = this.element.quantity;
                this.element.originalMaxQuantity = this.element.max_quantity;
                this.element.originalTagNumber = this.element.tag_number;
                this.element.quantity = 0;
                this.element.max_quantity = 0;
                this.element.tag_number = "";
            }
        },
        checkElementIsRabies(element) {
            if (element.item_type != ITEMTYPES.TYPES.TYPE_LAB) {
                const lowerCaseName = element.name.toLowerCase();
                return lowerCaseName.includes("rabies");
            }
        }
    }
};
</script>
<style>
.tag-number {
    margin-top: 5px;
}
</style>
